import { render } from "./MsgErrosAxios.vue?vue&type=template&id=15c314b2"
import script from "./MsgErrosAxios.vue?vue&type=script&lang=js"
export * from "./MsgErrosAxios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__